import { useEffect } from "react"


const getTextOfSelector = (id, isSortType = true) => {
    const value = '' + id

    if (isSortType) {
        switch (value) {
            case '0':
                return "بیشترین دانلود"
            case '1':
                return "کمترین دانلود"
            case '2':
                return "بیشترین خرید"
            case '3':
                return "کمترین خرید"

            default:
                return value
        }
    } else {
        switch (value) {
            case '0':
                return "هفته اخیر"
            case '1':
                return "ماه اخیر"
            case '2':
                return "3 ماه گذشته"

            default:
                return value
        }
    }
}

const TitleBarReportChartPage = ({ filters = { empty: '' }, chartFilters = { empty: '' }, sort = { sortType: '0', dateType: '1' } }) => {

    useEffect(() => {

        const top = Object.values(filters)?.filter(e => e !== "").length > 0 &&
            `<ul>
                ${chartFilters?.filterUserId ? `<li>${chartFilters.filterUserId.name}</li>` : ''}
                ${chartFilters?.publishDate ? `<li>سال ${chartFilters.publishDate.name}</li>` : ''}
                ${chartFilters?.ages ? `<li>رده سنی ${chartFilters.ages.name}</li>` : ''}
                ${chartFilters?.primarySubjectCategoryId ? `<li>دسته ${chartFilters.primarySubjectCategoryId.name}</li>` : ''}
                ${chartFilters?.secondarySubjectCategoryId ? `<li>دسته ثانویه ${chartFilters.primarySubjectCategoryId.name} - ${chartFilters.secondarySubjectCategoryId.name}</li>` : ''}
            </ul>
            <ul>
                ${filters?.filterUserId ? `<li>${filters.filterUserId.name}</li>` : ''}
                ${filters?.publishDate ? `<li>سال ${filters.publishDate.name}</li>` : ''}
                ${filters?.ages ? `<li>رده سنی ${filters.ages.name}</li>` : ''}
                ${filters?.primarySubjectCategoryId ? `<li>دسته ${filters.primarySubjectCategoryId.name}</li>` : ''}
                ${filters?.secondarySubjectCategoryId ? `<li>دسته ثانویه ${filters.primarySubjectCategoryId.name} - ${filters.secondarySubjectCategoryId.name}</li>` : ''}
            </ul>`

        const bottom = Object.values(sort)?.filter(e => e !== "").length > 0 &&
            `<div><b>براساس</b>
            <ul>
                ${(sort?.sortType)?.toString() && `<li>${getTextOfSelector(sort.sortType, true)}</li>`}
            </ul>
                <b style="margin-right: 6px">در </b>
            <ul>
                ${(sort?.dateType)?.toString() ? `<li>${getTextOfSelector(sort.dateType, false)}</li>` : ''}
                ${sort?.regDateFrom ? `<li>${sort.regDateFrom.replaceAll("-", "/")} ${sort?.regDateTo && `<span dir="ltr">تا ${sort.regDateTo.replaceAll("-", "/")}</span>`}</li>` : ''}
            </ul></div>`


        document.getElementById("topTitle").innerHTML = top ? top : ''
        document.getElementById("bottomTitle").innerHTML = bottom ? bottom : ''

    }, [filters, chartFilters, sort])


    return (<>
        <div className="reportTitleBar">




        </div>
    </>);
}

export default TitleBarReportChartPage;